export default __webpack_public_path__ + "static/media/PV-HOODIE-BACK.17567fd0.png";